import axios from "axios";
import { getDeviceType, getBrowserType, fetchApiData, checkOperatingSystem, fetchApiDataV2, updateApiDataV2, updateApiData } from "../utils/utils";
import { getTurnstileTokenValue } from "./turnstileToken";
const qs = require("query-string");

export const fetchAppInfo = async (params) => {
  // const website = "https://fishonnetworktv.gizmott.com"; // For development
  // const website = "https://staging.iptvsolutionsgroup.com"; 
  // const website = "https://uptown.gizmott.com";
  const website = window.location.origin // For LIVE
  // const website = "https://watch.tonictvnet.com"
  // const website = "https://staging.justwatchme.tv";
  // const website = "https://bountyhunterd.com";
  // const website = "https://chicanohollywood.tv";
  // const website = "https://hisadvocates.tv"
  // const website = "https://famigliadorotv.com"
  // const website = "https://mmatv.gizmott.com";
  // const website = "https://ceyflix.gizmott.com";
  // const website = "https://thehhntv.gizmott.com";
  // const website = 'https://royalktv.com';
  // const website = "https://thelaxxnetwork.com";
  // const website = 'https://dupontod.com';
  // const website = 'https://cpics.gizmott.com';
   //const website = "https://watch.foundtv.com";
   //const website = "https://watch.nextlevelsoul.com";
  // const website = 'https://elevationmovies.gizmott.com';
  // const website = 'https://artiflix.gizmott.com';
  // const website = 'https://uptown.tv';
  // const website = "https://fanward.gizmott.com";
  // const website = "https://4biddenknowledge.tv";
  // const website = "https://watchtvei.net";
  // const website = "https://spttv.gizmott.com";
  // const website = "https://thewutangcollection.com";
  // const website = "https://vosatv.gizmott.com"
  //const website = 'https://mood.gizmott.com';
  // const website = 'https://surfroots.gizmott.com';
  // const website = 'https://watch.onstageplus.com';
  // const website = 'https://fwfg2.gizmott.com';
  // const website = 'https://fwfg.gizmott.com';
  // const website = 'https://laughafterdark.gizmott.com';
  // const website = 'https://poppotv.gizmott.com';
  // const website = 'https://watch.fanward.com';
  // const website = "https://newblock.gizmott.com";
  // const website = "https://documentaryplus.gizmott.com";
  // const website = 'https://ciaousa.tv';
 // const website = 'https://sparktv.gizmott.com';
  // const website = 'https://godtvkids.gizmott.com'
  // const website = 'https://freelivesports.gizmott.com';
  // const website = 'https://powertubetv.gizmott.com';
  // const website = 'https://yowtv.gizmott.com';
  // const website = 'https://nouvelleframe.gizmott.com';
  // const website = 'https://demo.gizmott.com';
  // const website = 'https://freemovies.gizmott.com';
  // const website = 'https://christmasplus.gizmott.com';
//const website = "https://sikhflix.gizmott.com";

  const cfToken = getTurnstileTokenValue();
  const customConfig = {
    headers: {
      website: website,
      ...(cfToken && { "turnstile_token": cfToken }),
    },
    params: params && params,
  };
  return await axios.get(
    process.env.REACT_APP_API_URL + "config",
    customConfig
  );
};

export const fetchGeoInfo = async () => {
  return await axios.get(process.env.REACT_APP_API_URL + "ipinfo");
};

export const getLanguageList = async (appInfo) => {
  const api = "language/list";
  return await fetchApiDataV2(appInfo, api);
};

export const updateUserLanguage = async (appInfo, lanuguageId) => {
  const api = "user/language/update";
  const location = {
    path: "common",
    values: { language_id: lanuguageId }
  }
  return await updateApiDataV2(appInfo, api, location)
}
export const updateExternalUser = async (appInfo, token) => {
  const api = "account/verify";
  const location = {
    path: "common",
    values: { token }
  }
  return await updateApiDataV2(appInfo, api, location)
}
export const emailRequestCheck = async (appInfo, id) => {
  const api = "account/request/check";
  const params = {
    id
  }
  return await fetchApiData(appInfo, api, params)
}

export const guestUser = async (appInfo) => {
  let countryCode = appInfo?.projectDetails?.geoInfo?.countryCode;
  let ipaddress = appInfo?.projectDetails?.geoInfo?.query;
  let deviceId = appInfo?.projectDetails?.device_id;
  let pubid = appInfo?.projectDetails?.projectConfig?.pubid;
  let channelid = appInfo?.projectDetails?.projectConfig?.channelid;
  const customConfig = {
    headers: {
      pubid: pubid,
      channelid: channelid,
      country_code: countryCode,
      device_type: "web",
      dev_id: deviceId,
      ip: ipaddress,
      ua: navigator.userAgent,
    },
  };
  return await axios.post(
    process.env.REACT_APP_API_URL + "account/register/guest",
    "",
    customConfig
  );
};

export const authenticate = (appInfo) => {
  let uId = localStorage.getItem("gid");
  let countryCode = appInfo?.projectDetails?.geoInfo?.countryCode;
  let ipaddress = appInfo?.projectDetails?.geoInfo?.query;
  let deviceId = appInfo?.projectDetails?.device_id;
  let pubid = appInfo?.projectDetails?.projectConfig?.pubid;
  let channelid = appInfo?.projectDetails?.projectConfig?.channelid;
  let user_id = localStorage.getItem("userId");
  if (user_id) {
    uId = user_id;
  }
  const customConfig = {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "Access-Control-Allow-Origin": true,
      crossorigin: true,
      uid: uId,
      pubid: pubid,
      country_code: countryCode,
      channelid: channelid,
      dev_id: deviceId,
      ip: ipaddress,
      device_type: "web",
    },
  };
  return axios
    .get(process.env.REACT_APP_API_URL + "account/authenticate", customConfig)
    .then((response) => {
      if (response?.data?.message === "Invalid user") {
      } else {
        return response.data;
      }
    });
};

export const authenticate2 = async (appInfo) => {
  const url = `account/authenticate`;
  const response = await fetchApiData(appInfo, url);

  const data = response?.data;
  if (data?.user_language) {
    const currentLanguageCode = localStorage.getItem('selectedLanguageCode');
    const currentLanguageId = localStorage.getItem('selectedLanguageId');
    const currentLanguageName = localStorage.getItem('selectedLanguageName');

    const newCode = data?.user_language?.short_code;
    const newId = data?.user_language?.language_id != null ? data.user_language.language_id.toString() : null;
    const newName = data?.user_language?.language_name;

    if (currentLanguageCode !== newCode || currentLanguageId !== newId || currentLanguageName !== newName) {
      if (newCode) localStorage.setItem('selectedLanguageCode', newCode);
      if (newId) localStorage.setItem('selectedLanguageId', newId);
      if (newName) localStorage.setItem('selectedLanguageName', newName);
    }
  }

  return response;
};

export const applaunchEvent = async (event, appInfo, aiType) => {
  let sessionId = appInfo?.sessionId;
  let uId = localStorage.getItem("gid");
  let user_id = localStorage.getItem("userId");
  if (user_id) {
    uId = user_id;
  }
  let device_id = appInfo?.projectDetails?.device_id;
  let ctimestamp = Date.now().toString();
  let ctime = ctimestamp.slice(0, 10);
  let appid = appInfo?.projectDetails?.projectConfig?.app_id;
  let pubid = appInfo?.projectDetails?.projectConfig?.pubid;
  let channelid = appInfo?.projectDetails?.projectConfig?.channelid;
  const requestBody = {
    app_id: appid,
    timestamp: ctime,
    device_id: device_id,
    event_type: event,
    publisherid: pubid,
    user_id: uId,
    channel_id: channelid,
    session_id: sessionId,
    ai_type: aiType && aiType,
  };
  var token = appInfo?.accessToken;
  const customConfig = {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "Access-Control-Allow-Origin": true,
      crossorigin: true,
      "access-token": token,
    },
  };

  return await axios.post(
    "https://analytics.poppo.tv/event",
    qs.stringify(requestBody),
    customConfig
  );
};

export const analytics = (Response_uid, appInfo, Response_email, user_name) => {
  let countryCode = appInfo?.projectDetails?.geoInfo?.countryCode;
  localStorage.setItem("device_analytics", "true");
  let uId = Response_uid ? Response_uid : localStorage.getItem("gid");
  let user = localStorage.getItem("userId")

  let user_id = Response_uid ? Response_uid : localStorage.getItem("userId");
  if (user_id) {
    uId = user_id;
  }
  let deviceId = appInfo?.projectDetails?.device_id;
  var token = appInfo?.accessToken;
  let sessionId = appInfo?.sessionId;
  let userEmail = Response_email ? Response_email : "";

  let appid = appInfo?.projectDetails?.projectConfig?.app_id;
  let deviceType = getDeviceType();
  let ctimestamp = Date.now().toString();
  let ctime = ctimestamp.slice(0, 10);
  let browserType = getBrowserType();
  let pubid = appInfo?.projectDetails?.projectConfig?.pubid;
  let channelid = appInfo?.projectDetails?.projectConfig?.channelid;
  const customConfig = {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "Access-Control-Allow-Origin": true,
      crossorigin: true,
      "access-token": token,
    },
  };
  let currentLocation = appInfo?.projectDetails?.geoInfo;
  const data = {
    session_id: sessionId,
    device_id: deviceId,
    publisherid: pubid,
    channelid: channelid,
    app_id: appid,
    user_id: uId,
    ip_address: currentLocation?.query,
    ua: navigator.userAgent,
    timestamp: ctime,
    country: currentLocation?.country,
    device_type: deviceType,
    city: currentLocation?.city,
    latitude: currentLocation?.lat,
    longitude: currentLocation?.lon,
    width: window.innerWidth,
    height: window.innerHeight,
    device_make: navigator.userAgent,
    device_model: navigator.userAgent,
    browser: browserType,
    user_name: user ? user_name : "guest",
    user_email: userEmail ? userEmail : "",
    user_contact_number: "",
    country_code: countryCode,
  };
  return axios
    .post("https://analytics.poppo.tv/device", qs.stringify(data), customConfig)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return [];
    });
};

export const analytics2 = async (Response_uid, appInfo, Response_email, user_name) => {
  let countryCode = appInfo?.projectDetails?.geoInfo?.countryCode;
  let uId = Response_uid ? Response_uid : localStorage.getItem("gid");
  let user = localStorage.getItem("userId")
  let user_id = Response_uid ? Response_uid : localStorage.getItem("userId");
  if (user_id) {
    uId = user_id;
  }
  let deviceId = appInfo?.projectDetails?.device_id;
  let sessionId = appInfo?.sessionId;
  let userEmail = Response_email ? Response_email : "";

  let appid = appInfo?.projectDetails?.projectConfig?.app_id;
  let deviceType = getDeviceType();
  let ctimestamp = Date.now().toString();
  let ctime = ctimestamp.slice(0, 10);
  let browserType = getBrowserType();
  let pubid = appInfo?.projectDetails?.projectConfig?.pubid;
  let channelid = appInfo?.projectDetails?.projectConfig?.channelid;
  const customConfig = {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "Access-Control-Allow-Origin": true,
      crossorigin: true,
    },
  };
  let currentLocation = appInfo?.projectDetails?.geoInfo;
  const data = {
    session_id: sessionId,
    device_id: deviceId,
    publisherid: pubid,
    channelid: channelid,
    app_id: appid,
    user_id: uId,
    ip_address: currentLocation?.query,
    ua: navigator.userAgent,
    timestamp: ctime,
    country: currentLocation?.country,
    device_type: deviceType,
    city: currentLocation?.city,
    latitude: currentLocation?.lat,
    longitude: currentLocation?.lon,
    width: window.innerWidth,
    height: window.innerHeight,
    device_make: navigator.userAgent,
    device_model: navigator.userAgent,
    browser: browserType,
    user_name: user ? user_name : "guest",
    user_email: userEmail ? userEmail : "",
    user_contact_number: "",
    country_code: countryCode,
  };
  return await axios.post(
    "https://analytics.poppo.tv/device",
    qs.stringify(data),
    customConfig
  );
};

export const getPlayerToken = async (appInfo, id) => {
  const api = "playlistV2/generateToken";
  const params = {
    id: id
  }
  return await fetchApiData(appInfo, api, params)
};

export const affliateAnalytics = async (appInfo) => {
  let deviceType;
  if (checkOperatingSystem() === "android") {
    deviceType = "Android"
  } else if (checkOperatingSystem() === "iPhone") {
    deviceType = "iPhone"
  }
  let pubid = appInfo?.projectDetails?.projectConfig?.pubid;
  let channelid = appInfo?.projectDetails?.projectConfig?.channelid;
  const url = localStorage.getItem("affliateUrl")
  const unique = deviceType && appInfo?.projectDetails?.geoInfo?.query + deviceType;
  let params = { url: url, source_application: document.referrer, unique_device_id: unique }
  let uid = localStorage.getItem("gid");
  let user_id = localStorage.getItem("userId");
  if (user_id) {
    uid = user_id;
  }
  const customConfig = {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "Access-Control-Allow-Origin": true,
      crossorigin: true,
      pubid: pubid,
      channelid: channelid,
      uid: uid,
      device_type: "web"
    },
    params: params
  };

  return await axios.get(
    process.env.REACT_APP_API_URL + "affiliate/analytics",
    customConfig
  );
};
export const updateContinueWatching = async (appInfo, videoId) => {
  const api = "user/continueWatching/remove";
  const location = {
    path: "common",
    values: { video_id: videoId }
  };
  return await updateApiData(appInfo, api, location);
};

export const updateWatchlistData = async (appInfo, showId, flag) => {
  const api = `watchlist/show/${showId}/${flag}`;
  return await fetchApiData(appInfo, api);
};

export const updateVideoWatchlistData = async (appInfo, videoId, flag) => {
  const api = `watchlist/video/${videoId}/${flag}`;
  return await fetchApiData(appInfo, api);
};

export const getUserSubscription = async (appInfo) => {
  const api = "subscription/user";
  return await fetchApiData(appInfo, api);
};

export const getUserLastSubscriptionDetails = async (appInfo) => {
  const api = "subscription/lastExpired";
  return await fetchApiData(appInfo, api);
};

export const logoutAll = async (appInfo) => {
  const api = "account/logoutall";
  return await fetchApiData(appInfo, api);
};

export const fetchEventDetails = async (appInfo, eventId) => {
  const api = "subscription/event";
  const params = {
    event_id: eventId
  }
  return await fetchApiData(appInfo, api, params)
}
export const updateUserRating = async (appInfo, values) => {
  const api = "user/rating"
  const data = {
    show_id: values?.showId,
    rating: values?.ratedCount,
    review: values?.review
  }
  const location = {
    path: "common",
    values: data
  }
  return await updateApiData(appInfo, api, location)
}

export const getUpdatePaymentLink = async (appInfo) => {
  const api = `user/paymentMethod/session`
  return await updateApiData(appInfo, api)
}

export const setParentalPin = async (appInfo, pin) => {
  const api = "user/parentalPin/set";
  const location = {
    path: "common",
    values: { pin },
  };
  return await updateApiDataV2(appInfo, api, location);
};

export const verifyParentalPin = async (appInfo, pin) => {
  const api = "user/parentalPin/verify";
  const location = {
    path: "common",
    values: { pin },
  };
  return await updateApiDataV2(appInfo, api, location);
};

export const listVideosByDate = async (appInfo, startDate, endDate) => {
  const api = "calendar/list";
  const params = {
    start_date: startDate,
    end_date: endDate,
  };
  return await fetchApiData(appInfo, api, params);
};

export const addVideoToDate = async (appInfo, videoId, date) => {
  const api = "calendar/add";
  const location = {
    path: "common",
    values: {
      video_id: videoId,
      date: date,
    },
  };
  return await updateApiData(appInfo, api, location);
};

export const fetchCalendarVideos = async (appInfo, searchKey = "") => {
  const api = "calendar/videos";
  const params = searchKey ? { key: searchKey } : {};
  return await fetchApiData(appInfo, api, params);
};

export const deleteVideoFromCalendar = async (appInfo, calendarId) => {
  const api = "calendar/delete";
  const location = {
    path: "common",
    values: {
      calendar_id: calendarId,
    },
  };
  return await updateApiData(appInfo, api, location);
};

export const updateVideoComplete = async (appInfo, calendarId, completed) => {
  const api = "calendar/video/complete";
  const location = {
    path: "common",
    values: {
      calendar_id: calendarId,
      completed: completed,
    },
  };
  return await updateApiData(appInfo, api, location);
}
